<!-- @format -->

<div
	class="product-card-wrapper hmf-grid hmf-span-12"
	[ngClass]="{
		'hmf-mb-s': !isSponsored || !showNewSponsoredLabel,
		'hmf-mb-0': (isSponsored || isNikeExclusive) && showNewSponsoredLabel,
		disabled: isDisabled
	}">
	<div class="product-card-badge hmf-span-10">
		<homefield-product-badge
			pageType="plp"
			aria-hidden="true"
			[imageBadgeName]="badge"
			[hasMobileAndDesktopImage]="false"
			[chainIdentifierAbbr]="chainAbbr"></homefield-product-badge>
	</div>
	<div
		id="product-card"
		class="product-card-content hmf-span-12">
		<div class="inner-wrapper hmf-pb-xxs">
			<!-- This will be switched out for the product image component -->
			<div class="product-card-image hmf-mt-xxs hmf-mb-xs">
				<a
					role="button"
					class="image"
					tabindex="-1"
					aria-hidden="true"
					[href]="isDisabled ? 'javascript:void(0)' : updatedAssetSeoUrl"
					[class.disabled]="isDisabled"
					[title]="title"
					(click)="productCardClicked()">
					<span class="product-image-span hmf-display-flex hmf-justify-content-center">
						<homefield-product-image
							#productCardImage
							[imageUrl]="imageUrl"
							[ecode]="ecode"
							[defaultColor]="colors && colors.length > 0 ? colors[0] : null"
							[productName]="title"
							[selectedSwatchColor]="selectedSwatchColor"
							[isLCPImage]="isLCPImage"
							[isNgOptimizedImageSupported]="
								isNgOptimizedImageSupported
							"></homefield-product-image>
					</span>
				</a>
			</div>

			<!-- Switch to product-swatch component -->
			<div class="swatches-container hmf-mb-xs">
				@if (imageSwatchesEnabled()) {
					<homefield-product-card-image-swatches
						[colors]="colors"
						[ecode]="ecode"
						[assetSeoUrl]="pdpUrl"
						(selectedSwatchColorChange)="colorSwatchChanged($event)"
						(extraColorsClick)="productCardClicked()">
					</homefield-product-card-image-swatches>
				} @else {
					<homefield-product-card-color-swatches
						[colors]="colors"
						[ecode]="ecode"
						[assetSeoUrl]="pdpUrl"
						(selectedSwatchColorChange)="colorSwatchChanged($event)"
						(extraColorsClick)="productCardClicked()">
					</homefield-product-card-color-swatches>
				}
			</div>

			<a
				homefield-product-title
				[ngClass]="{ 'favorite-product-title-link': inMauiList }"
				class="product-title-link hmf-body-m hmf-header-m-xs hmf-mb-xxs hmf-mb-m-0"
				[linkURL]="updatedAssetSeoUrl"
				[title]="title"
				[ariaLabel]="productCardAriaLabel"
				tabindex="0"
				(click)="productCardClicked()"
				(keydown.enter)="productCardClicked()">
				{{ title }}
			</a>

			@if (inMauiList && !isUnavailable) {
				<div
					class="hmf-mt-xxs hmf-mb-xs list-attribute-container"
					[ngClass]="{ 'list-attribute-container--oos': isOOS }">
					@if (
						!sharedList() &&
						!sku &&
						!isOOS &&
						!isCustomOrPersonalizedProduct &&
						!isRecommendedList() &&
            hasDefiningAttributes()
					) {
						<button
							hmf-action-text
							class="sku-resolve-text"
							(click)="openSkuResolvePanel()">
							Select Options
						</button>
					}

					@if (favoritesAttributes.length) {
						<div class="hmf-display-flex hmf-flex-wrap">
							@for (
								attr of favoritesAttributes | slice: 0 : 3;
								track trackByFn(i, attr);
								let i = $index
							) {
								<p
									class="favorite-attribute label-base-subtle hmf-subheader-xs hmf-mb-0 hmf-display-flex">
									{{ attr.title }}: {{ attr.value }}
									@if (
										i !== favoritesAttributes.length - 1 ||
										(favoritesAttributes.length <= 3 &&
											i === favoritesAttributes.length)
									) {
										<span>,&nbsp;</span>
									}
								</p>
							}
							@if (favoritesAttributes.length > 3) {
								<p
									class="favorite-attribute label-base-subtle hmf-subheader-xs"
									(click)="openAttributesPanel(true)"
									(keydown.enter)="openAttributesPanel(true)">
									<span class="hmf-text-decoration-underline"
										>View all details</span
									>
								</p>
							}
						</div>
					}
				</div>
			}

			@if (isOOS && !isUnavailable) {
				<div
					class="oos-container"
					[ngClass]="{ 'hmf-mb-m': sharedList() }">
					<p class="label-negative hmf-mb-0">Sorry, this item is out of stock.</p>
					@if (!sharedList()) {
						<p
							class="hmf-mb-0 hmf-text-decoration-underline"
							(click)="ecodeSelectedEmitter()"
							(keydown.enter)="ecodeSelectedEmitter()">
							Shop Similar
						</p>
					}
				</div>
			}

			@if (isUnavailable) {
				<p class="label-negative product-unavailable">
					<homefield-icon
						width="20px"
						name="alert-info-fill"
						class="unavailable-icon"
						fill="var(--hmf-fill-negative)"></homefield-icon>
					Product details failed to load
				</p>
			}

			<a
				role="button"
				class="image"
				tabindex="-1"
				aria-hidden="true"
				[href]="isDisabled ? 'javascript:void(0)' : updatedAssetSeoUrl"
				[class.disabled]="isDisabled"
				[title]="title"
				(click)="productCardClicked()"
				(keydown.enter)="productCardClicked()">
				<!-- Product price, price range, was price ( see price in cart )-->
				@if (!isUnavailable && !isOOS) {
					<div class="product-pricing hmf-mb-xs">
						<homefield-price
							[pricingInfo]="prices"
							[isSeePriceInCart]="mapPriceIndicator === 1"
							[isClearance]="priceIndicator === 0"></homefield-price>
						<homefield-strikethrough-price
							[pricingInfo]="prices"
							[isClearance]="priceIndicator === 0"></homefield-strikethrough-price>
					</div>
				}

				<!-- Customer rating -->

				@if (showCustomerRating) {
					<div class="rating-container">
						<hmf-star-ratings
							[ratingCount]="ratingCount"
							[ratingValue]="ratingValue"
							[showCustomerRating]="showCustomerRating && !isSponsored">
						</hmf-star-ratings>
					</div>
				}

				<!-- Promotion Message -->
				<div class="hmf-mb-xxs promo-message">
					@if (promo && !(isUnavailable || isOOS)) {
						<homefield-promotion>
							{{ promo }}
						</homefield-promotion>
					}
				</div>

				<hr class="divider hmf-m-0" />

				<!-- availability component -->
				@if (productAvailabilityData && availabilityOnProductCardsEnabled) {
					<homefield-availability
						[productAvailabilityData]="productAvailabilityData"
						[selectedStoreId]="selectedStoreId"
						[isOOS]="isOOS"
						[isComingSoon]="isComingSoon"></homefield-availability>
				}
			</a>
			@if (!productAvailabilityData && availabilityOnProductCardsEnabled) {
				<div class="hmf-my-xxs availability-loader"></div>
			}

			@if (!isNikeExclusive) {
				<div
					class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
					@if (isOOS || isUnavailable) {
						<p class="hmf-label-l out-of-stock hmf-mb-xxxs">OUT OF STOCK</p>
					} @else {
						@if (productQuickViewEnabled) {
							<button
								hmf-button
								id="add-to-cart-button"
								class="hmf-px-0 hmf-py-0"
								[ngClass]="{ 'hmf-px-xs hmf-px-sm-0': chainAbbr === 'pl' }"
								aria-label="Add To Cart"
								[disabled]="isDisabled"
								[icon]="'order-cart-fill'"
								[label]="'Add To Cart'"
								[loading]="false"
								[size]="'medium'"
								[text]="'Add To Cart'"
								[variant]="'secondary'"
								(click)="openQuickview()"></button>
						}
					}
				</div>
			}
			@if (isNikeExclusive) {
				<div
					class="button-container hmf-display-flex hmf-justify-content-center hmf-align-items-center">
					<a
						homefield-button
						class="hmf-mx-xxxs hmf-pb-xxxs hmf-bt-xxs"
						variant="tertiary"
						[href]="learnMoreUrl">
						Learn More
					</a>
				</div>
			}
		</div>
	</div>
	<!-- end product card div-->

	@if ((isSponsored || isNikeExclusive) && showNewSponsoredLabel) {
		<div class="sponsored hmf-legal-s">Sponsored</div>
	}
</div>
